import React, { useState } from "react";
import Chart from "react-apexcharts";
import PopupComponent from "@components/PopupComponent";

import { analyzeData } from "@helpers/chartsHelpers";
import ReactJson from "react-json-view";
import TitleComponent from "@components/TitleComponent";
import { useTheme } from "@stores/ThemeContext";

import { useTranslation } from "react-i18next";

import { ANALYZE_DATA_TIMEOUT } from "./constants";

const ChartComponent = ({ title, custom = false }) => {
  const { t: translate, i18n } = useTranslation();

  const [popupData, setPopupData] = useState(null);
  const [response, setResponse] = useState(null);
  const [validChart, setValidChart] = useState(false);
  const [tempResponse, setTempResponse] = useState(null);
  const { isDarkMode, toggleTheme } = useTheme();

  const showPopup = (data) => {
    setPopupData(data || "No popup content available");
  };
  const [chartOptions2, setChartOptions2] = useState();
  const [chartSeries2, setChartSeries2] = useState();

  return (
    <div className="p-4 bg-white rounded shadow-md">
      <div className="flex justify-between mb-4">
        <div className="flex gap-4 items-center">
          <TitleComponent text={title} size="md" />
        </div>
        <span className="text-sm text-gray-500">
        </span>
      </div>
      {!response && (
        <textarea
          className={`w-full h-60 border-4 p-2 rounded ${
            validChart ? "border-green-300" : "border-red-300"
          }`}
          value={tempResponse}
          placeholder="Enter JSON response here"
          onChange={(e) => {
            setTempResponse(e.target.value);
            if (tempResponse !== response) {
              setValidChart(false);
            }
          }}
        />
      )}
      {!response && (
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-300 disabled:text-gray-500 mb-5"
          onClick={() => {
            setValidChart(false);
            setResponse(null);
            try {
              if (JSON.parse(tempResponse)) {
                const parsedResponse = JSON.parse(tempResponse);
                setResponse(parsedResponse);
                setChartOptions2(
                  analyzeData(
                    parsedResponse,
                    showPopup,
                    "custom-chart",
                    isDarkMode,
                    ANALYZE_DATA_TIMEOUT
                  ).chartOptions
                );
                setChartSeries2(
                  analyzeData(
                    parsedResponse,
                    showPopup,
                    "custom-chart",
                    isDarkMode,
                    ANALYZE_DATA_TIMEOUT
                  ).chartSeries
                );
                setValidChart(true);
              }
            } catch (e) {
              setValidChart(false);
              alert("Please enter a valid JSON response");
            }
          }}
          disabled={validChart}
        >
          {translate("charts.generate")}
        </button>
      )}
      {response && (
        <ReactJson
          src={response}
          collapsed={true}
          enableClipboard={false}
          displayDataTypes={false}
          displayObjectSize={true}
          quotesOnKeys={false}
          displayArrayKey={false}
          theme="apathy:inverted"
          name={"Your JSON Response"}
        />
      )}

      {response && (
        <button
          className="bg-red-500 text-white px-4 py-2 rounded disabled:bg-gray-300 disabled:text-gray-500 mt-5"
          onClick={() => {
            setValidChart(false);
            setResponse(null);
          }}
        >
          {translate("charts.edit-json")}
        </button>
      )}
      {validChart && (
        <>
          <Chart
            options={chartOptions2}
            series={chartSeries2}
            type="line"
            height={350}
          />
          <input type="hidden" id={`current_page_custom-chart`} value={0} />
        </>
      )}
      {popupData && (
        <PopupComponent
          open={popupData !== null}
          innerHtml={popupData}
          setPopupOpen={() => {
            setPopupData(null);
          }}
        />
      )}
    </div>
  );
};

export default ChartComponent;
